export default __webpack_public_path__ + "4934ebe8bd02e783720edb7786008e14.svg";